import { keepPreviousData, useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiAnalysisSalesShow } from '@/types/serializers';

// 売上インサイトAPIのクエリパラメータ型
export interface SalesQueryParams {
  from: string;
  to: string;
  granularity: 'day' | 'week' | 'month';
  filter_organization_user_ids?: number[];
  filter_target: 'candidate' | 'company';
  filter_company_tag_ids?: number[];
  filter_job_tag_ids?: number[];
  filter_candidate_tag_ids?: number[];
}

/**
 * 売上インサイトデータ（サマリー / トレンド / 担当者別・成約先別・ポジション別）を取得するフック。
 */
export default function useFetchAnalysisSales(
  params: SalesQueryParams,
  options?: { enabled?: boolean }
) {
  const query = qs.stringify(params, { arrayFormat: 'brackets' });

  return useQuery<AgentApiAnalysisSalesShow>({
    queryKey: ['/agent/api/analysis/sales', query],
    queryFn: async () => {
      const response = await fetch(`/agent/api/analysis/sales.json?${query}`);
      if (!response.ok) {
        throw new Error('売上データの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiAnalysisSalesShow>;
    },
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}
